<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Supplier"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="baseView.id"
        recordType="Supplier"
      />
    </template>

    <div class="css-v2 grid-report" v-if="loaded">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../_services/storage";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "supplier-transaction-history",
      backButtonRoute: `/supplier`,
      model: {
        Code: "",
        Name: "",
      },
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Transactions",
            message: "Currently there are no transactions for this supplier.",
          },
        },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },
      loaded: false,
    };
  },
  computed: {
    tabs() {
      return [
        {
          text: "Details",
          path: `/supplier/review/${this.baseView.id}`,
          applicationFeatureCode: "Customer",
        },
        {
          text: "Contacts",
          path: `/supplier-contact/${this.baseView.id}`,
          applicationFeatureCode: "Customer",
        },
        {
          text: "Notes",
          path: `/supplier-note/${this.baseView.id}`,
          applicationFeatureCode: "Customer",
        },
        {
          text: "Transactions",
          path: `/supplier-transaction-history/${this.baseView.id}`,
          applicationFeatureCode: "SupplierTransactionHistory",
        },
      ];
    },
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      config.filter = [["SupplierCode", "=", this.baseView.id]];
      return config;
    },

    columns() {
      var cols = this.report.columns;
      // supplier-transaction uses the same screen layout
      // supplier-transaction-history should not display the Supplier field
      // find it and delete it
      for (var i = 0; i < cols.length; i++) {
        if (cols[i]["screenField"] == "Supplier") {
          cols.splice(i, 1);
          // break;
        }

        if (cols[i]["screenField"] == "SupplierReference") {
          cols[i].width = "unset";
          cols[i].minWidth = "200px";
        }
      }
      return cols;
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");
    this.selectedIndex = 3;
    let response = await ScreenLayoutService.getByRoute(
      "supplier-transaction-history"
    );
    if (response.data.value) {
      this.report = JSON.parse(response.data.value[0].Definition);
    }

    var that = this;

    await SupplierService.getByCode(this.baseView.id).then(async (response) => {
      if (response.data.value.length > 0) {
        that.model.Code = response.data.value[0].Code;
        that.model.Name = response.data.value[0].Name;
        that.refreshView();
      }
    });
    this.loaded = true;
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
  },
};
</script>
